// Installer notifications are now handled by Firebase Functions
// No frontend email sending needed - Functions trigger on Firestore updates

export async function sendJobCompletedEmail(job, installer, feedback, notes) {
  // Firebase Function will detect status change and send email automatically
}

export async function sendIssueReportedEmail(job, installer, issueDetails) {
  // Firebase Function will detect flagged=true and send email automatically
}

export async function sendNoteAddedEmail(job, installer, noteText) {
  // Firebase Function will detect new note in array and send email automatically
}